import React from "react";

export const GoalContext = React.createContext({});
